import "core-js/modules/es.error.cause.js";
import { uploadFile, addIntermediary, editIntermediary } from './request';
import { cryptoDecrypt } from '@/utils/aes';
export default {
  data() {
    return {
      dialogVisible: false,
      dataFrom: {
        intermediaryId: '',
        name: '',
        logo: '',
        disclosurePageName: '',
        disclosurePageLink: '',
        icpNo: '',
        icpLink: ''
      },
      isAdd: true,
      type2: false,
      isDisclosureLink: false,
      isIcpLink: false,
      action: uploadFile,
      headers: {
        'X-Dispatch': 'Upload',
        'X-Version': 'upload'
      },
      loading: false
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请至少输入名称')
        }],
        disclosurePageName: [{
          required: this.isDisclosureLink,
          trigger: 'blur',
          message: this.$t('请输入披露页名称')
        }],
        disclosurePageLink: [{
          required: this.isDisclosureLink,
          validator: this.checkDisclosurePageLink,
          trigger: 'change'
        }, {
          pattern: /^(?:(?:(?:https?|ftp):)?\/\/)?(?:[a-zA-Z0-9-]\.)?([a-zA-Z0-9-]+)(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?$/,
          message: '请输入正确的链接',
          trigger: 'blur'
        }],
        icpNo: [{
          required: this.isIcpLink,
          trigger: 'blur',
          message: this.$t('请输入icp备案号')
        }],
        icpLink: [{
          required: this.isIcpLink,
          validator: this.checkIcpLink,
          trigger: 'change'
        }, {
          pattern: /^(?:(?:(?:https?|ftp):)?\/\/)?(?:[a-zA-Z0-9-]\.)?([a-zA-Z0-9-]+)(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?$/,
          message: '请输入正确的链接',
          trigger: 'blur'
        }]
      };
    },
    checkDisclosurePageLink() {
      return (rule, value, callback) => {
        if (this.isDisclosureLink) {
          if (value == '') {
            callback(new Error(this.$t('请输入披露页链接')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
    },
    checkIcpLink() {
      return (rule, value, callback) => {
        if (this.isIcpLink) {
          if (value == '') {
            callback(new Error(this.$t('请输入icp备案号链接')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
    }
  },
  methods: {
    init(data, type, type2) {
      this.type2 = type2;
      console.log(data.intermediaryId, 55, data);
      this.isAdd = data.name ? false : true;
      if (data.id) {
        this.dataFrom = Object.assign({}, this.dataFrom, data);
        this.isDisclosureLink = this.dataFrom.disclosurePageLink != '' ? true : false;
        this.isIcpLink = this.dataFrom.icpLink != '' ? true : false;
      }
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          if (this.isAdd) {
            addIntermediary(this.dataFrom).then(res => {
              this.$message.success(this.$t('操作成功') + '!');
              this.loading = false;
              this.$emit('ok', this.isAdd, res.intermediaryId, this.type2);
              this.$emit('cancel');
            });
          } else {
            editIntermediary(this.dataFrom).then(res => {
              this.$message.success(this.$t('操作成功') + '!');
              this.loading = false;
              this.$emit('ok', this.isAdd);
              this.$emit('cancel');
            });
          }
        }
      });
    },
    // 上传限制
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('请按正确格式上传logo'));
      }
      const isLt300kb = file.size / 1024 < 300;
      if (!isLt300kb) {
        this.$message.error(this.$t('上传文件超过300kb'));
      }
      return isJpgOrPng && isLt300kb;
    },
    handleChange({
      file
    }) {
      if (file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (file.status === 'done') {
        this.dataFrom.logo = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        this.loading = false;
      }
    },
    disclosureChange(e) {
      this.isDisclosureLink = e.target.checked;
      this.dataFrom.disclosurePageLink = '';
    },
    icpChange(e) {
      this.isIcpLink = e.target.checked;
      this.dataFrom.icpLink = '';
    },
    // 去除前后空格
    handleBlurTrim(name, e) {
      this.dataFrom[name] = e.target.value.trim();
    }
  }
};